import {
  IBenefit,
  IFullPlanDetail,
  IFullPlanDetailPPO,
} from "../../../interfaces/api";

import DoctorsDrugsTilePlan from "./DoctorsDrugsTilePlan.component";

const DataTableDetailPlanDoctors = ({
  data,
}: {
  data: IFullPlanDetail | IFullPlanDetailPPO;
}) => {
  const getDoctorsBenefits = (data: IFullPlanDetail) => {
    let copay: IBenefit[] = [];

    data.PlanDetails[0].company[0].healthPlan[0].pbp[0].group.forEach(
      (group) => {
        if (group.pbpBenefitGroup === ("Premiums and Benefits" as string)) {
          group.category.forEach((category) => {
            if (category.pbpBenefitCategory === ("Doctor visits" as string)) {
              copay = category.benefit;
            }
          });
        }
      }
    );

    return copay;
  };

  const benefits = getDoctorsBenefits(data as IFullPlanDetail);
  const copay = benefits.find(
    (benefits) => benefits.pbpBenefitName === "Physician Specialist Services"
  );
  return (
    <div
      className="grid-x"
      style={{
        backgroundColor: "white",
        border: "1px solid #D3E1F0",
        textAlign: "left",
      }}
    >
      <div
        className="grid-x hide-for-small-only"
        style={{
          width: "100%",
          padding: "32px 20px",
          borderBottom: "1px solid #D3E1F0",
        }}
      >
        <div
          className="cell small-4"
          style={{ fontSize: "18px", fontWeight: 500 }}
        >
          PCP Copay
        </div>
        <div className=" cell small-8" style={{ paddingLeft: 20 }}>
          {data.PlanDetails[0].PCPCopayInNetworkAmount >= 0
            ? data.PlanDetails[0].PCPCopayInNetworkAmount % 1 !== 0
              ? "$" + data.PlanDetails[0].PCPCopayInNetworkAmount.toFixed(2)
              : "$" + data.PlanDetails[0].PCPCopayInNetworkAmount
            : "-"}
        </div>
      </div>
      <div
        className="grid-x show-for-small-only"
        style={{
          width: "100%",
          padding: "32px 10px",
          borderBottom: "1px solid #D3E1F0",
        }}
      >
        <div className="cell small-4" style={{ fontSize: 14, fontWeight: 500 }}>
          PCP Copay
        </div>
        <div
          className=" cell small-8"
          style={{ paddingLeft: 20, fontSize: 14 }}
        >
          {data.PlanDetails[0].PCPCopayInNetworkAmount >= 0
            ? data.PlanDetails[0].PCPCopayInNetworkAmount % 1 !== 0
              ? "$" + data.PlanDetails[0].PCPCopayInNetworkAmount.toFixed(2)
              : "$" + data.PlanDetails[0].PCPCopayInNetworkAmount
            : "-"}
        </div>
      </div>
      <div
        className="grid-x hide-for-small-only"
        style={{
          width: "100%",
          padding: "32px 20px",
          borderBottom: "1px solid #D3E1F0",
        }}
      >
        <div
          className="cell small-4"
          style={{ fontSize: "18px", fontWeight: 500 }}
        >
          Specialist Copay
        </div>
        <div className=" cell small-8" style={{ paddingLeft: 20 }}>
          {copay && copay.pbpBenefitDesc
            ? copay.pbpBenefitDesc
                .replace(/\\*\\n/g, "\n")
                .replace(/\\/g, "")
                .split("\n")
                .filter(Boolean)
                .map((line, index) => <div key={index}>{line}</div>)
            : "-"}
        </div>
      </div>{" "}
      <div
        className="grid-x show-for-small-only"
        style={{
          width: "100%",
          padding: "32px 10px",
          borderBottom: "1px solid #D3E1F0",
        }}
      >
        <div
          className="cell small-4"
          style={{ fontSize: "14px", fontWeight: 500 }}
        >
          Specialist Copay
        </div>
        <div
          className=" cell small-8"
          style={{ paddingLeft: 20, fontSize: 14 }}
        >
          {copay && copay.pbpBenefitDesc
            ? copay.pbpBenefitDesc
                .replace(/\\*\\n/g, "\n")
                .replace(/\\/g, "")
                .split("\n")
                .filter(Boolean)
                .map((line, index) => <div key={index}>{line}</div>)
            : "-"}
        </div>
      </div>
      <DoctorsDrugsTilePlan planData={data} />
    </div>
  );
};

export default DataTableDetailPlanDoctors;
